import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Excluded, ExcludedGamesType } from '../models'
import getAllGamesExtraReducer from '../thunks/get-all-games.thunk'

import getExcludedGamesExtraReducer from '../thunks/get-excluded-games.thunk'
import saveExcludedGamesExtraReducer from '../thunks/save-excluded-games.thunk'
import initialState from './initial-state'

export const excludedGamesSlice = createSlice({
  name: 'excludedGames',
  initialState,
  reducers: {
    setExcludedGamesAction(state, action: PayloadAction<ExcludedGamesType>) {
      state.excludedGames = action.payload
    },
    setCurrentGameAction(state, action: PayloadAction<Excluded>) {
      state.currentGame = action.payload
    },
  },
  extraReducers: (builder) => {
    getAllGamesExtraReducer(builder)
    getExcludedGamesExtraReducer(builder)
    saveExcludedGamesExtraReducer(builder)
  },
})

export const ExcludedGamesActions = excludedGamesSlice.actions
